module.exports = __webpack_public_path__ + "img/industry-img3.e743b1a8.png";